import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../ManagedCDN.css';

const AuroraDBHe = () => {
    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>מסד נתונים Amazon Aurora מנוהל - שירותי DBA מקצועיים | Epicfinal</title>
                <meta name="title" content="מסד נתונים Amazon Aurora מנוהל - שירותי DBA מקצועיים | Epicfinal" />
                <meta name="description" content="שירות מסד נתונים Amazon Aurora מנוהל. הקמה מלאה, ניטור 24/7, אופטימיזציית שאילתות, ניהול גיבויים, טלאי אבטחה וכיוונון ביצועים. תמיכת DBA מומחה כלולה." />
                <meta name="keywords" content="Amazon Aurora, Aurora מנוהל, מסד נתונים Aurora, ניהול AWS Aurora, ניהול מסדי נתונים, Aurora MySQL, Aurora PostgreSQL, שירותי DBA, אופטימיזציית מסדי נתונים, כיוונון שאילתות, גיבוי מסדי נתונים, ניטור Aurora, מסד נתונים מנוהל, מסד נתונים בענן" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/aurora-database" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/aurora-database" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/aurora-database" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/aurora-database" />
                <meta property="og:title" content="מסד נתונים Amazon Aurora מנוהל | Epicfinal" />
                <meta property="og:description" content="ניהול מסד נתונים Aurora מומחה. הקמה, ניטור, אופטימיזציית שאילתות וניהול גיבויים עם תמיכת DBA 24/7." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal Aurora מנוהל - ניהול מסדי נתונים מומחה" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/aurora-database" />
                <meta name="twitter:title" content="מסד נתונים Amazon Aurora מנוהל | Epicfinal" />
                <meta name="twitter:description" content="ניהול מסד נתונים Aurora מומחה עם ניטור 24/7 ותמיכת DBA." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "מסד נתונים Amazon Aurora מנוהל",
                        "description": "ניהול מלא של מופעי מסד נתונים Amazon Aurora כולל הקמה, ניטור, אופטימיזציה, ניהול גיבויים וכיוונון ביצועים",
                        "provider": {"@type": "Organization", "name": "Epicfinal", "url": "https://epicfinal.com"},
                        "serviceType": "ניהול מסדי נתונים",
                        "areaServed": "Worldwide",
                        "url": "https://epicfinal.com/he/aurora-database"
                    }
                `}</script>
            </Helmet>

            <div className="managed-cdn-page">
                <section className="cdn-hero">
                    <div className="container">
                        <div className="cdn-hero-content">
                            <div className="cdn-icon-badge">
                                <i className="las la-database"></i>
                            </div>
                            <h1 className="cdn-hero-title">
                                מסד נתונים Amazon Aurora מנוהל
                            </h1>
                            <p className="cdn-hero-subtitle">
                                ניהול מקצועי של מסדי נתונים עבור Amazon Aurora
                            </p>
                            <p className="cdn-hero-description">
                                ניהול מלא של מופע מסד הנתונים Amazon Aurora שלכם – כולל הקמה, ניטור, אופטימיזציה, ניהול גיבויים וכיוונון ביצועים, כדי להבטיח שמסד הנתונים שלכם יפעל בצורה חלקה ויעילה.
                            </p>
                            <div className="cdn-hero-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-amazon-aurora-database&language=hebrew&currency=2"
                                    className="btn-cdn btn-primary" target="_blank" rel="noopener noreferrer">
                                    קבלו הצעת מחיר
                                </a>
                                <Link to="/contact1" className="btn-cdn btn-secondary">
                                    דברו עם מומחה
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cdn-features">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>ניהול מסדי נתונים מקצועי</h2>
                            <p>שמרו על מסד נתונים Aurora שלכם אופטימלי ומאובטח</p>
                        </div>
                        <div className="cdn-features-grid">
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-cogs"></i>
                                </div>
                                <h3>הקמת מסד נתונים</h3>
                                <p>הגדרה ופריסה מלאה של Aurora, המותאמות לעומסי העבודה שלכם.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-chart-line"></i>
                                </div>
                                <h3>ניטור ביצועים</h3>
                                <p>ניטור רציף של שאילתות, חיבורים וניצול משאבים.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-tachometer-alt"></i>
                                </div>
                                <h3>אופטימיזציית שאילתות</h3>
                                <p>זיהוי ואופטימיזציה של שאילתות איטיות לשיפור ביצועי מסד הנתונים.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-database"></i>
                                </div>
                                <h3>ניהול גיבויים</h3>
                                <p>הגדרת גיבויים אוטומטיים, ניטור ותהליכי שחזור.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-shield-alt"></i>
                                </div>
                                <h3>עדכוני אבטחה</h3>
                                <p>טלאי אבטחה קבועים וניהול תאימות (Compliance) עבור מסד הנתונים שלכם.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-tools"></i>
                                </div>
                                <h3>תחזוקה</h3>
                                <p>חלונות תחזוקה מתוזמנים עם הפרעה מינימלית לשירותים שלכם.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cdn-included">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>מה כלול בשירות</h2>
                            <p>ניהול Aurora מקיף</p>
                        </div>
                        <div className="cdn-included-grid">
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> הקמה והגדרה</h3>
                                <ul>
                                    <li><i className="las la-angle-right"></i> פריסת מסד נתונים</li>
                                    <li><i className="las la-angle-right"></i> אופטימיזציית פרמטרים</li>
                                    <li><i className="las la-angle-right"></i> הגדרת Read Replica</li>
                                    <li><i className="las la-angle-right"></i> ניהול חיבורים (Connection Pooling)</li>
                                </ul>
                            </div>
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> ביצועים ואופטימיזציה</h3>
                                <ul>
                                    <li><i className="las la-angle-right"></i> ניתוח ביצועי שאילתות</li>
                                    <li><i className="las la-angle-right"></i> אופטימיזציית אינדקסים</li>
                                    <li><i className="las la-angle-right"></i> כיוונון משאבים</li>
                                    <li><i className="las la-angle-right"></i> פתרון צווארי בקבוק</li>
                                </ul>
                            </div>
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> אבטחה ותחזוקה</h3>
                                <ul>
                                    <li><i className="las la-angle-right"></i> טלאי אבטחה</li>
                                    <li><i className="las la-angle-right"></i> ניהול גיבויים</li>
                                    <li><i className="las la-angle-right"></i> ניטור רציף</li>
                                    <li><i className="las la-angle-right"></i> תמיכת מומחים</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="cdn-pricing">
                    <div className="container">
                        <div className="cdn-pricing-card">
                            <div className="cdn-pricing-header">
                                <h2>ניהול מסד נתונים Aurora</h2>
                                <p>תמחור בהתאמה אישית לדרישות שלכם</p>
                            </div>
                            <div className="cdn-pricing-body">
                                <div className="cdn-pricing-amount">
                                    <span className="cdn-price">מותאם אישית</span>
                                    <span className="cdn-period">צרו קשר להצעה</span>
                                </div>
                                <ul className="cdn-pricing-features">
                                    <li><i className="las la-check"></i> הקמה והגדרת מסד נתונים Aurora</li>
                                    <li><i className="las la-check"></i> ניטור ביצועים רציף</li>
                                    <li><i className="las la-check"></i> אופטימיזציית שאילתות</li>
                                    <li><i className="las la-check"></i> ניהול גיבויים</li>
                                    <li><i className="las la-check"></i> עדכוני אבטחה וטלאים</li>
                                    <li><i className="las la-check"></i> הגדרת זמינות גבוהה</li>
                                    <li><i className="las la-check"></i> תמיכת DBA צמודה</li>
                                    <li><i className="las la-check"></i> דוחות ביצועים חודשיים</li>
                                </ul>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-amazon-aurora-database&language=hebrew&currency=2"
                                    className="cdn-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    בקשו הצעת מחיר
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cdn-cta">
                    <div className="container">
                        <div className="cdn-cta-content">
                            <h2>מוכנים לבצע אופטימיזציה למסד הנתונים שלכם?</h2>
                            <p>תנו למומחי מסדי הנתונים שלנו לנהל את תשתית ה-Aurora שלכם.</p>
                            <div className="cdn-cta-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-amazon-aurora-database&language=hebrew&currency=2"
                                    className="btn-cdn btn-light" target="_blank" rel="noopener noreferrer">
                                    בקשו הצעת מחיר
                                </a>
                                <a href="https://meetings.hubspot.com/viacheslav-seifer"
                                    className="btn-cdn btn-outline" target="_blank" rel="noopener noreferrer">
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default AuroraDBHe;
